import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { VanPhoto } from "../../../types/types"

interface VanPhotoState {
  vanPhotos: VanPhoto[]
  loading: boolean
  error: string | null
}

const initialState: VanPhotoState = {
  vanPhotos: [],
  loading: false,
  error: null
}

const vanPhotoSlice = createSlice({
  name: "vanPhoto",
  initialState,
  reducers: {
    setVanPhotos: (state, action: PayloadAction<VanPhoto[]>) => {
      state.vanPhotos = action.payload
    },
    addVanPhoto: (state, action: PayloadAction<VanPhoto>) => {
      if (!state.vanPhotos) {
        state.vanPhotos = []
      }
      state.vanPhotos.push(action.payload)
    },
    updateVanPhoto: (state, action: PayloadAction<VanPhoto>) => {
      if (!state.vanPhotos) {
        state.vanPhotos = []
      }
      const index = state.vanPhotos.findIndex(v => v.id === action.payload.id)
      if (index !== -1) {
        state.vanPhotos[index] = action.payload
      }
    },
    deleteVanPhoto: (state, action: PayloadAction<number>) => {
      if (!state.vanPhotos) {
        state.vanPhotos = []
      }
      state.vanPhotos = state.vanPhotos.filter(v => v.id !== action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    resetVanPhotos: (state) => {
      state.vanPhotos = []
      state.loading = false
      state.error = null
    }
  }
})

export const {
  setVanPhotos,
  addVanPhoto,
  updateVanPhoto,
  deleteVanPhoto,
  setLoading,
  setError,
  resetVanPhotos
} = vanPhotoSlice.actions

export default vanPhotoSlice.reducer